module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/wizard/hero-small.2700db83fce3c8e230125c68ffdc2e3c.jpg";